// test315
(315 && 0);
